import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { AuthService, UserType  } from './auth.service';

const HOME_ROUTE_BY_ROLE: Record<UserType, string> = {
  superadmin: '/dashboard',
  admin: '/admin',
  user: '/user',
};

/**
 * Bounces unauthenticated visitors to /login before any protected screen loads. Routes also
 * carry a `data: { role }` marking which of the three tiers they belong to — an authenticated
 * admin or user typing a superadmin URL directly (e.g. /org-list) gets redirected to their
 * own home instead of silently seeing superadmin-only screens the sidebar never links them to.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private readonly auth: AuthService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (!this.auth.isAuthenticated()) return this.router.parseUrl('/login');

    const requiredRole = route.data['role'] as UserType | undefined;
    const currentRole = this.auth.getUserType();
    if (requiredRole && requiredRole !== currentRole) {
      return this.router.parseUrl(HOME_ROUTE_BY_ROLE[currentRole]);
    }
    return true;
  }
}
